import { useTheme } from "@mui/material";
import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";

interface StatInfoCardProps {
  value: number;
  label: string;
  color: string;
}

const StatInfoCard = ({ value, label, color }: StatInfoCardProps) => {
  const { palette } = useTheme();

  return (
    <DSBox
      sx={{
        bgcolor: palette.action.hover,
        p: 2,
        borderRadius: 2,
        minWidth: 120,
        textAlign: "center",
      }}
    >
      <DSTypography sx={{ fontSize: 28, fontWeight: "bold", color }}>
        {value}
      </DSTypography>
      <DSTypography sx={{ color: palette.text.secondary, fontSize: 13 }}>
        {label}
      </DSTypography>
    </DSBox>
  );
};

export default StatInfoCard;
